import { useAppConfiguration } from '@mews-commander/data-access';
import { Optional } from '@mews/std';
import { ImageResizeMode } from '@mews/enums';
import { getImageUrlOrNull } from './getImageOrNull';

export const useImageSrc = (
    imageId: Optional<string>,
    { mode = ImageResizeMode.CoverExact }: { mode?: ImageResizeMode } = {}
) => {
    const { imageBaseUrl } = useAppConfiguration();

    return getImageUrlOrNull(imageBaseUrl)({ imageId, mode });
};
